import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../axiosInstance';
import {
  errorResponseParser,
  successResponseParser,
} from '../../utils/handlers';

export const stpfcapprovaldetails = createAsyncThunk(
  'stpfcapprovaldetails',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const employeeId = JSON.parse(
        localStorage.getItem('userData')
      )?.employeeId;
      const res = await axios.get(`/getSTPFCApprovalDetail`, {
        params: { employeeId },
      });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const stpfcApprovalEmployeeWiseDetails = createAsyncThunk(
  'stpfcApprovalEmployeeWiseDetails',
  async ({ employeeId, stpfcId }, { rejectWithValue }) => {
    try {
      const res = await axios.get('/getSTPFCApprovalEmployeeWiseDetails', {
        params: { employeeId, stpfcId },
      });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error));
    }
  }
);

export const stpfcApprovalSubmit = createAsyncThunk(
  'stpfcApprovalSubmit',
  async (Submitdata, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post('/stpfcApprovalSubmit', Submitdata);
      return successResponseParser(response);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

const stpfcdetails = createSlice({
  name: 'stpfcdetails',
  initialState: {
    isLoading: false,
    data: [],
    employeedata: [],
    //Submitdata:[],
    successMessage: '',
    apiError: '',
  },
  reducers: {
    resetEmployeeData: (state, action) => {
      state.employeedata = action.payload; // Reset data
    },
  },

  extraReducers: (builder) => {
    builder.addCase(stpfcapprovaldetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(stpfcapprovaldetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(stpfcapprovaldetails.rejected, (state, action) => {
      state.apiError = action.payload || 'Something went wrong';
      state.isLoading = false;
      state.data = null;
    });
    builder.addCase(stpfcApprovalEmployeeWiseDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      stpfcApprovalEmployeeWiseDetails.fulfilled,
      (state, action) => {
        state.isLoading = false;
        state.employeedata = action.payload;
      }
    );
    builder.addCase(
      stpfcApprovalEmployeeWiseDetails.rejected,
      (state, action) => {
        state.apiError = action.payload || 'Something went wrong';
        state.isLoading = false;
        state.employeedata = null;
      }
    );
    builder.addCase(stpfcApprovalSubmit.pending, (state) => {
      state.isLoading = true;
      state.success = false;
      state.successMessage = '';
    });
    builder.addCase(stpfcApprovalSubmit.fulfilled, (state, action) => {
      state.isLoading = false;
      state.Submitdata = action.payload;
      state.successMessage =
        action.payload?.fileRecord?.[0]?.status || 'Success';
      state.success = true;
    });
    builder.addCase(stpfcApprovalSubmit.rejected, (state, action) => {
      state.apiError = action.payload || 'Something went wrong';
      state.Submitdata = null;
      state.isLoading = false;
    });
  },
});

export const { resetEmployeeData } = stpfcdetails.actions;
export default stpfcdetails.reducer;
